import { NgModule } from '@angular/core';
import { UserChooseCompanyScreenComponent } from './user-choose-company.screen.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [UserChooseCompanyScreenComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    TranslateModule,
    ComponentsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: '',
        component: UserChooseCompanyScreenComponent,
      },
    ]),
  ],
})
export class UserChooseCompanyScreenModule {}
